export default __webpack_public_path__ + "static/media/more-active.0ae53b78.svg";